import { SubAPI } from "./SubAPI";
export class Keying extends SubAPI {
    list(props) { return this.fetcher.get("/api/keying", props); }
    listNames(props) { return this.fetcher.get("/api/keying/names", props); }
    upsertName(input) { return this.fetcher.post("/api/keying/name", input); }
    set(input) { return this.fetcher.post("/api/keying/set-for-door", input); }
    bulkUpdate(list) { return this.fetcher.post("/api/keying/bulk-set-for-door", list); }
    getDetailsForPO(input) { return this.fetcher.get("/api/keying/details-for-po", input); }
}
